import behaviorsImport from '../behaviors/afterInitBehaviors';

export default behaviorsImport;
